import React from "react";

const PRIMARY = "#1d4ed8";
const NAVY = "#0f1c3f";
const LIGHT = "#e8f0fe";

// Shown when the user clicks "Confirm & Pay" on a facility booking, before
// createBooking() is ever called — this booking flow is card-only
// (BookingController::manualConfirm rejects shroff/manual payment for
// bookings outright, see bookingService.js), so this just makes that
// restriction explicit up front instead of the user only discovering it
// inside BookingPaymentModal. "Pay Now" hands control back to the caller to
// run the existing createBooking()/openPaymentGateway() flow unchanged;
// "Cancel" just closes this and nothing has been booked or locked yet.
export default function OnlinePaymentOnlyModal({ onCancel, onConfirm }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm" role="dialog" aria-modal="true">
      <div className="relative w-full max-w-sm bg-white rounded-2xl shadow-2xl p-6 text-center">
        <div className="mx-auto w-14 h-14 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: LIGHT }}>
          <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke={PRIMARY}>
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.8}
              d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
            />
          </svg>
        </div>
        <h2 className="text-lg font-bold" style={{ color: NAVY }}>Online Payment Only</h2>
        <p className="text-sm text-gray-500 mt-2 leading-relaxed">
          Please note that this booking can only be completed using online payment. Shroff/manual payment is not available.
        </p>
        <div className="flex flex-col gap-2.5 mt-6">
          <button
            type="button"
            onClick={onConfirm}
            className="w-full px-5 py-2.5 rounded-xl text-sm font-semibold text-white transition shadow-md hover:shadow-lg"
            style={{ backgroundColor: PRIMARY, boxShadow: `0 4px 12px ${PRIMARY}4d` }}
          >
            Pay Now
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="w-full px-5 py-2.5 rounded-xl text-sm font-medium text-gray-500 hover:text-gray-700 border border-gray-200 hover:bg-gray-50 transition"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
